
//const API_HOST = 'http://bodybackend.pm/';
// const API_HOST = 'http://toofanimastibackend.pm';
const API_HOST = 'https://toofanimastibackend.pmcommu.in';


export default API_HOST;